import React from 'react';
import { IconProps } from './IconProps'; // Assuming IconProps is in the same directory

const MenuIcon: React.FC<IconProps> = ({ className, title, onClick }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      fill="none" 
      viewBox="0 0 24 24" 
      strokeWidth="1.5" 
      stroke="currentColor" 
      className={className} 
      aria-hidden={!title} // Hide from screen readers if title is not provided for decorative icons
      onClick={onClick} // Pass onClick handler if provided
      // Add role="img" and accessible title if it's meaningful and not just decorative
      // For a button icon, aria-label should be on the button itself.
    >
      {title && <title>{title}</title>}
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
    </svg>
  );
};

export default MenuIcon; 